/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var UserPermission;
(function (UserPermission) {
    UserPermission["VIEW_USERS"] = "ViewUsers";
    UserPermission["JOB_VIEW"] = "JobView";
    UserPermission["JOB_CREATION"] = "JobCreation";
    UserPermission["JOB_DEPLOY"] = "JobDeploy";
    UserPermission["JOB_LOGS"] = "JobLogs";
    UserPermission["JOB_COMMENT"] = "JobComment";
    UserPermission["PUB_SUB_LOGS"] = "PubSubLogs";
    UserPermission["INTEGRATION_CONFIG"] = "IntegrationConfig";
    UserPermission["USER_MANAGEMENT"] = "UserManagement";
    UserPermission["SUPPORT_DASHBOARD"] = "SupportDashboard";
    UserPermission["DEBUG_TOOLS"] = "DebugTools";
})(UserPermission || (UserPermission = {}));
